export const ApiUrl = "https://admin.yashodaseeds.com/api";


export const BaseUrl = "https://admin.yashodaseeds.com/support/public/upload/";



    